import * as reducers from './reducers';

const importAddonReducers = (config) => {
  config.addonReducers = {
    ...config.addonReducers,
    ...reducers,
  };
  return config;
};

const applyConfig = (config) => {
  config.settings.plugAreaComponent = { add: { before: null, after: null } };

  return config;
};

export { importAddonReducers };
export default applyConfig;
